import { useAppDisplayModeContext } from '@archipro-design/aria';

import {
    ScrollReveal,
    type ScrollRevealProps,
} from '~/ui-rocco/pages/home-page/components/ScrollReveal';

/**
 * ScrollReveal for the detail pages: desktop keeps the fade-and-rise reveal,
 * mobile renders the content in place with no animation — on phones the
 * pre-reveal dim reads as missing content rather than choreography. An
 * explicit `animate={false}` opts a desktop owner out of the fade as well.
 * `onReveal` timing is unchanged in every case, so owners deferring work
 * (carousel autoplay) behave identically.
 */
export const DetailScrollReveal = ({
    animate = true,
    ...props
}: ScrollRevealProps) => {
    const { mobile } = useAppDisplayModeContext();
    return <ScrollReveal {...props} animate={animate && !mobile} />;
};
